module.exports = __webpack_public_path__ + "img/res03.7e6829b4.png";